interface ImgixSourceOptions {
    width?: number;
    height?: number;
}

export const imgixSource = (src: string, options: ImgixSourceOptions) => {
    let source = `${src}?auto=format`;
    const { width, height } = options;

    if (width) {
        source += `&w=${width}`;
    }

    if (height) {
        source += `&h=${height}`;
    }

    return source;
};

export const imgixSrcSet = (src: string) => {
    return `${src} 1x, ${src}&dpr=2&q=30&fit=max 2x, ${src}&dpr=3&q=15&fit=max 3x`;
};
